const ROOT = 'CipReport/filter/operator';

export const FETCH_OPERATOR_REQUEST = `${ROOT}/FETCH_OPERATOR_REQUEST`;
export const FETCH_OPERATOR_SUCCESS = `${ROOT}/FETCH_OPERATOR_SUCCESS`;
export const FETCH_OPERATOR_FAILURE = `${ROOT}/FETCH_OPERATOR_FAILURE`;
export const FETCH_REFRESHTOKEN_REQUEST = `${ROOT}/FETCH_REFRESHTOKEN_REQUEST`;
